<template>
    <div class="content">
        <header>
            <div class="banner">
                <van-row>
                    <van-col span="6" @click="back"><img class="back-icon" src="@/assets/theme/light/status/01dailyActive/01back.svg"></van-col>
                    <van-col span="12">
                        <div class="banner-title">{{ $t('sleepStage.title') }}</div>
                    </van-col>
                </van-row>
            </div>
        </header>
        <div class="desc-box">
            <div class="desc-title">{{$t('sleepStage.title')}}</div>
            <div class="desc-info">{{$t('sleepStage.desc0')}}</div>
            <div class="desc-title">{{$t('sleepStage.title1')}}</div>
            <div class="desc-info">{{$t('sleepStage.desc1')}}</div>
            <div class="desc-title">{{$t('sleepStage.title2')}}</div>
            <div class="desc-info">{{$t('sleepStage.desc2')}}</div>
            <div class="desc-title">{{$t('sleepStage.title3')}}</div>
            <div class="desc-info">{{$t('sleepStage.desc3')}}</div>
            <div class="desc-title">{{$t('sleepStage.title4')}}</div>
            <div class="desc-info last-desc">{{$t('sleepStage.desc4')}}</div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'sleepStage',
        methods: {
            back() {
                this.$router.go(-1)
            }
        }
    }
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/status/07sleepStage.vue